<template>
  <div class="card-body">
    <slot>
      <template v-if="title || text">
        <h5 v-if="title" class="card-title">{{ title }}</h5>
        <p v-if="text" v-html="text" class="card-text"></p>
      </template>
    </slot>
  </div>
</template>

<script>
export default {
  name: "BaseCardBody",
  props: {
    text: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
  }
};
</script>